import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type SiteFrameProps = {
  children: ReactNode;
  outerClassName?: string;
  innerClassName?: string;
};

export const SiteFrame = ({
  children,
  outerClassName,
  innerClassName,
}: SiteFrameProps) => {
  return (
    <div className={cn("mx-auto w-full", outerClassName)}>
      <div
        className={cn(
          "mx-auto w-full max-w-[var(--breakpoint-xl)]",
          innerClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};
